"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../index");
class AttributeSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearchFocused: false,
            keypathSearch: '',
        };
        this.getFilteredKeyPaths = this.getFilteredKeyPaths.bind(this);
    }
    getFilteredKeyPaths() {
        const { keyPaths } = this.props;
        const { keypathSearch } = this.state;
        return keyPaths.reduce((prev, curr) => {
            if (keypathSearch === '' || curr.keyPath.toLowerCase().includes(keypathSearch.toLowerCase())) {
                return prev.concat(curr.keyPath);
            }
            return prev;
        }, []);
    }
    render() {
        const { device, onSelect, selected, selectorAnimationDirection } = this.props;
        const { isSearchFocused, keypathSearch } = this.state;
        return (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                position: 'absolute',
                top: 56,
                left: 0,
                zIndex: 3,
                width: device === 'Mobile' ? '100%' : 384,
                height: device === 'Mobile' ? '100%' : 378,
                background: index_1.white,
                animation: `${selectorAnimationDirection} 150ms ease-in-out`,
            } },
            React.createElement(index_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({ isSearchFocused: false }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (search) => this.setState({ keypathSearch: search }), text: keypathSearch, style: {
                    width: undefined,
                } }),
            React.createElement("div", { style: {
                    height: '100%',
                    overflowY: 'scroll',
                    paddingBottom: device === 'Mobile' ? 56 : 0,
                } },
                React.createElement(index_1.SelectableList, { device: device }, this.getFilteredKeyPaths().map((keyPath, index) => (React.createElement("div", { key: index, style: {
                        alignItems: 'center',
                        display: 'flex',
                        height: device === 'Mobile' ? 72 : 56,
                        justifyContent: 'space-between',
                        width: '100%',
                    }, onClick: () => onSelect(keyPath) },
                    React.createElement(index_1.Text, { text: keyPath.replace(new RegExp('^attributes.'), ''), size: device === 'Mobile' ? 'large' : 'medium' }),
                    React.createElement(index_1.RadioButton, { selected: selected === keyPath, style: {
                            outerStyle: {
                                height: 18,
                                width: 18,
                            },
                        } }))))))));
    }
}
exports.default = AttributeSelector;
